import { render, staticRenderFns } from "./drjingCode.vue?vue&type=template&id=bfcbd500&scoped=true&"
import script from "./drjingCode.vue?vue&type=script&lang=js&"
export * from "./drjingCode.vue?vue&type=script&lang=js&"
import style0 from "./drjingCode.vue?vue&type=style&index=0&id=bfcbd500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcbd500",
  null
  
)

export default component.exports